<template>
  <div class="main">
    <div class="title"></div>
    <!--  表单 -->
    <div class="form">
      <div class="tip">带<span>*</span>为必填项目</div>
      <div class="form-item">
        <p>姓名<span>*</span></p>
        <div class="form-item-input">
          <input type="text" placeholder="请在此输入您的姓名" v-model="nameVal" maxlength="8" @input="inputNum($event, 'name')">
          <span>{{nameNum}}/8</span>
        </div>
      </div>
      <div class="form-item">
        <p>手机号<span>*</span></p>
        <div class="form-item-input">
          <input type="text" placeholder="请在此输入您的手机号" v-model="phoneVal" maxlength="11" @input="inputNum($event, 'phone')">
          <span>{{phoneNum}}/11</span>
        </div>
      </div>
      <div class="form-item">
        <p>身份证号<span>*</span></p>
        <div class="form-item-input">
          <input type="text" placeholder="请在此输入您的身份证号" v-model="cardVal" maxlength="18" @input="inputNum($event, 'card')">
          <span>{{cardNum}}/18</span>
        </div>
      </div>
      <div class="form-item">
        <p>所在地区<span>*</span></p>
        <div class="form-item-select">
          <div @click="choose">
            <input disabled :value="provinceval" type="text" @change="choose">
            <!-- <select disabled name="" id="" @change="choose"> -->
            <!-- </select> -->
            <span>省</span>
          </div>
          <div @click="choose">
            <input disabled :value="cityval" type="text" @change="choose">
            <!-- <select name="" id=""> -->
            <!-- </select> -->
            <span>市</span>
          </div>
          <div @click="choose">
            <input disabled :value="areaval" type="text" @change="choose">
            <!-- <select name="" id=""> -->
            <!-- </select> -->
            <span>区</span>
          </div>
        </div>
      </div>
      <div class="form-item">
        <p>梦想标题<span>*</span></p>
        <div class="form-item-input">
          <input type="text" placeholder="请在此输入您的梦想标题" v-model="titleVal" maxlength="50" @input="inputNum($event, 'title')">
          <span>{{titleNum}}/50</span>
        </div>
      </div>
      <div class="form-item">
        <p>我的梦想<span>*</span></p>
        <div class="form-item-input form-item-textarea">
          <textarea placeholder="请在此输入您的梦想，描述越完整越有可能被我们选中！" v-model="contentVal" maxlength="1000" @input="inputNum($event, 'content')"></textarea>
          <span>{{contentNum}}/1000</span>
        </div>
      </div>
      <div class="form-item">
        <p>我的梦想图片<small>（可选）</small></p>
        <div class="inpit-tip">可上传照片，大小不超过10M。</div>
        <div class="flexdiv" style="display:flex;flex-">
        <div class="imglists" v-for="(item,index) in imgarr" :key="item.index" :style="'background-image: url(' + item + ')'">
          <span @click="delimg(index)"></span>
        </div>
        <!-- <div class="imglists" v-for="(item,index) in imgarr" :key="item.index"><img :src="item" alt=""></div> -->
        <div class="form-item-file" v-if="imgarr.length < 9 ">
            <div>
              <img src="../assets/images/add.png" alt="">
              添加照片
            </div>
            <input type="file" @change="uploadimg($event)">
            
        </div>
        </div>

      </div>

      <!-- 按钮 -->
      <div class="buttons">
        <div class="cancel" @click="cancel">取消</div>
        <div class="submit" @click="onSubmit">确认提交</div>
      </div>
    </div>
    <!-- 弹窗 -->
    <div class="pop-box" v-show="showPop">
      <div class="pop">
        <img src="../assets/images/error.png" alt="">
        <p v-html="msg"></p>
      </div>
    </div>
    <!-- 加载 -->
    <div class="loading" v-if="isloading">
      <img src="../assets/images/Loading.png" alt="">
    </div>
    <div class="mask" v-if="show" @click="choose" @touchmove.prevent></div>
    <div class="divwrap" v-if="show">
        <v-distpicker type="mobile" @province="onChangeProvince" @city="onChangeCity" @area="onChangeArea"></v-distpicker>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
        imgarr : [],
        nameVal: '',
        nameNum: 0,
        phoneVal: '',
        phoneNum: 0,
        cardVal: '',
        cardNum: 0,
        titleVal: '',
        titleNum: 0,
        contentVal: '',
        contentNum: 0,
        showPop: false,
        msg: '必填项',
        selected : [],
        selected2 : [],
        show:false,
        provinceval:'',
        cityval:'',
        areaval:'',
        isloading: false
    }
  },
  methods: {
    // 表单监控输入
    inputNum(e, type) {
      switch (type) {
        case 'name':
          this.nameNum = e.target.value.length;
          break;
        case 'phone':
          this.phoneNum = e.target.value.length;
          break;
        case 'card':
          this.cardNum = e.target.value.length;
          break;
        case 'title':
          this.titleNum = e.target.value.length;
          break;
        case 'content':
          this.contentNum = e.target.value.length;
          break;
        default:
          break;
      }
    },

    // 取消
    cancel() {
      this.$router.push({path: '/'});
    },

    // 提交
    onSubmit() {
      let _this = this;
      //匹配手机号
      let regPhone = /^1[0-9]{10}$/;
      if (!regPhone.test(_this.phoneVal)) {
        this.popShow('手机号格式不正确!');
        return false;
      }
      // 匹配身份证号码
      let regCard = /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/;
      if (!regCard.test(_this.cardVal)) {
        this.popShow('身份证号格式不正确!');
        return false;
      }
      if (_this.nameVal.length > 0 && _this.phoneVal.length > 0 && _this.cardVal.length > 0 && _this.titleVal.length > 0 && _this.contentVal.length > 0) {
        _this.isloading = true;
        this.$http.post('/h5/gsBankDream/create', {
          name: _this.nameVal,
          mobile: _this.phoneVal,
          identity: _this.cardVal,
          region: _this.provinceval,
          city: _this.cityval,
          area: _this.areaval,
          dreamTitle: _this.titleVal,
          dreamDetail: _this.contentVal,
          dreamImage: _this.imgarr
        }).then((res) => {
          _this.isloading = false;
          if (res.data.code == '0') {
            this.$router.push({path: '/results'});
          } else if (res.data.code == '-1') {
            _this.msg = '&emsp;您已报名成功，<br/>&emsp;请勿重复提交。';
            
          }
          else {
            alert(res.data.message);
          }
        })
      } else {
        _this.popShow('必填项未填写完整!');
      }
        
    },
    // 上传图片
    uploadimg(e){
      var _this = this;
      var file = e.target.files[0];
      let fd  = new FormData();
      fd.append("file",file);
      _this.$http.post('/h5/gsBankDream/upload', fd)
      .then( (res)=> {
        var file = "http://" + res.data.data.url;
        _this.imgarr.push(file);
        console.log(_this.imgarr);
      })
    },
    // 弹窗
    popShow(text) {
      this.msg = text;
      this.showPop = true;
      setTimeout(() => {
        this.showPop = false;
      }, 2000);
    },
    delimg(e){
      this.imgarr.splice(e,1) 
    },
    choose(){
        this.show=!this.show;
    },
    onChangeProvince(a){
        this.provinceval = a.value;
        console.log(document.getElementsByClassName('divwrap')[0]);
        document.getElementsByClassName('divwrap')[0].scrollTop = 0;
    },
    onChangeCity(a){
        this.cityval = a.value
        document.getElementsByClassName('divwrap')[0].scrollTop = 0;
    },
    onChangeArea(a){
        this.areaval = a.value
        document.getElementsByClassName('divwrap')[0].scrollTop = 0;
        this.show=false
    },
  }
}
</script>
<style scoped>
input{
  border: none;
  outline: none;
  padding: 0;
}
textarea{
  border: none;
  outline: none;
}
.main {
  background-color: #cecece;
  overflow: hidden;
}
.title {
  width: 100%;
  height: 3.2rem;
  background: url('../assets/images/banner.jpg') no-repeat;
  background-size: cover;
  background-position: center -2rem;
}
.form {
  width: 90%;
  background-color: #fff;
  margin: -0.55rem auto 0.38rem;
  border-radius: 0.2rem;
  box-sizing: border-box;
  padding: 0.25rem 0.35rem;
}
.tip {
  font-size: 0.22rem;
  color: #3e3e3e;
  margin-bottom: 0.36rem;
}
.tip span {
  color: #b91b21;
}
.form-item {
  width: 100%;
}
.form-item p {
  font-size: 0.36rem;
  color: #3e3e3e;
  margin: 0 0 0.16rem;
}
.form-item p span {
  color: #b91b21;
}
.form-item .inpit-tip {
  font-size: 0.22rem;
  color: #999;
  margin-bottom: 0.2rem;
}
/* input表单 */
.form-item-input {
  width: 100%;
  height: 0.54rem;
  line-height: 0.54rem;
  border: 0.01rem solid #a0a0a0;
  border-radius: 0.54rem;
  box-sizing: border-box;
  padding: 0 0.3rem;
  margin-bottom: 0.3rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.form-item-input input {
  width: 5rem;
  height: 0.3rem;
  font-size: 0.22rem;
}
.form-item-input span {
  color: #999999;
}
/* 选择器表单 */
.form-item-select {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 0.3rem;
}
.form-item-select input {
  width: 1.44rem;
  height: 0.52rem;
  line-height: 0.52rem;
  border: 0.01rem solid #a0a0a0;
  border-radius: 0.5rem;
  background: url('../assets/images/arrow-down.png') no-repeat;
  background-size: 0.24rem;
  background-position: 1rem center;
  box-sizing: border-box;
  padding: 0 0.3rem 0 0.2rem;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  margin-right: 0.1rem;
}
/* 文本域表单 */
.form-item-textarea {
  height: 2.5rem;
  box-sizing: border-box;
  border-radius: 0.3rem;
  padding: 0.16rem 0.3rem;
  flex-direction: column;
  align-items: flex-end;
}
.form-item-textarea textarea {
  width: 100%;
  height: 100%;
  font-size: 0.22rem;
}
.form-item-textarea span {
  /* margin-top: 1rem; */
}
/* 上传表单 */
.form-item-file {
  width: 1.96rem;
  height: 1.35rem;
  background-color: #d3d3d3;
  position: relative;
}
.form-item-file div {
  font-size: 0.22rem;
  color: #a0a0a0;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
.form-item-file div img {
  width: 0.34rem;
  margin-bottom: 0.12rem;
}
.form-item-file input {
  width: 100%;
  height: 100%;
  display: inline-block;
  opacity: 0;
  position: absolute;
  top: 0;
  left: 0;
}
.imglists span {
  width: 0.25rem;
  height: 0.25rem;
  text-align: center;
  line-height: 0.25rem;
  background: #b91b21 url('../assets/images/remove-file.png') no-repeat;
  background-size: 0.12rem 0.12rem;
  background-position: center;
  border-radius: 50%;
  position: absolute;
  top: -0.12rem;
  right: -0.12rem;
}

/* 按钮 */
.buttons {
  width: 100%;
  margin-top: 0.5rem;
  /* width: 2.9rem;
  height: 0.8rem; */
  display: flex;
  justify-content: space-between;
}
.buttons div {
  width: 2.9rem;
  height: 0.8rem;
  font-size: 0.36rem;
  color: #fff;
  text-align: center;
  line-height: 0.8rem;
  border-radius: 0.8rem;
}
.cancel {
  background-color: #999;
  box-shadow: 0 0 0.2rem 1px rgba(153,153,153,0.5);
}
.submit {
  background-color: #b91b21;
  box-shadow: 0 0 0.2rem 1px rgba(122,8,8,0.3);
}

.flexdiv{
  display: flex;
  flex-wrap: wrap;
}
.imglists{
  width: 1.96rem;
  height: 1.35rem;
  margin-right:2%;
  margin-bottom:2%;
  position: relative;
  background-size: cover;
  background-position: center;
  /* overflow: hidden; */
  position: relative;
}
.imglists img{
  width:100%;
  height:100%;
  /* transform: scale(1.5); */
}
.imglists span {
  width: 0.25rem;
  height: 0.25rem;
  text-align: center;
  line-height: 0.25rem;
  background: #b91b21 url('../assets/images/remove-file.png') no-repeat;
  background-size: 0.12rem 0.12rem;
  background-position: center;
  border-radius: 50%;
  position: absolute;
  top: -0.12rem;
  right: -0.12rem;
  z-index: 1;
}
.divwrap{
    height: 200px;
    overflow-y: auto;
    position: fixed;
    left: 0;
    bottom: 0;
    width: 100%;
    z-index: 100;
    background: #fff;
}
.mask{
  width: 100%;
  height: 100%;
  z-index: 98;
  position: fixed;
  top: 0;left: 0;
  background: rgba(0, 0, 0, 0.69);
}
.distpicker-address-wrapper{
      -webkit-overflow-scrolling: liuhx !important;
}
/* 弹窗 */
.pop-box {
  width: 100%;
  height: 100%;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 99;
  background-color: rgba(0, 0, 0, 0.7);
}
.pop {
  width: 5.82rem;
  height: 4.28rem;
  background-color: #fff;
  border-radius: 0.3rem;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
.pop img {
  width: 1.9rem;
  margin-bottom: 0.5rem;
  margin-left: 0.3rem;
}
.pop p {
  font-size: 0.36rem;
  margin: 0;
}
/* 加载 */
.loading {
  width: 100%;
  height: 100%;
  position: fixed;
  top: 0;
  left: 0;
  background-color: rgba(0, 0, 0, 0.7);

}
.loading img {
  width: 0.5rem;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  animation: loading 2s linear infinite;
}
@keyframes loading {
  0% {
    transform: translate(-50%, -50%) rotate(0);
  }
  100% {
    transform: translate(-50%, -50%) rotate(360deg);
  }
}
</style>